<template>
  <div v-if="me" class="page-container">
    <KycForm @emitResult="emitResult" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  components: { KycForm: () => import('@/components/kyc/Form.vue') },
  created() {
    _meta({
      titles: ['정보입력'],
    })
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['registerWooriCrowd']),
  },
  methods: {
    ...mapActions('kyc', ['addCdd', 'getMobileAuthUrl']),
    async emitResult(result) {
      if (!result) {
        return
      }
      if (await redirectSignupManage()) {
        return
      }
      return await this.$router.push('/signup/store')
    },
  },
}
</script>
